import {ErrorOrigin, getExplanationText, PaymentFailedDialogContent} from "@bounce/shared/consumer/pages/payment";
import {ERRORS_WITH_CUSTOM_HANDLING} from "@bounce/shared/enums";
import {InputUtils} from "@bounce/shared/helpers";
import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import React, {useEffect, useMemo} from "react";
import {useGetContactDetailQuery} from "~/api/requests";
import {Pages} from "~/bi-events/enum";
import {useWebchat} from "~/components/webchat/useWebchat";
import {useAmplitude, useConsumerUser} from "~/contexts";

interface IPaymentFailedDialog extends NiceModalHocProps {
  error: string;
  errorReason?: string;
  errorExplanation?: string;
  errorOrigin?: ErrorOrigin;
  errorCode?: string;
}

const PaymentFailedDialog = NiceModal.create(
  ({error, errorReason, errorExplanation, errorOrigin, errorCode}: IPaymentFailedDialog) => {
    const {pageViewEvent, pageClickEvent} = useAmplitude();
    const contactDetail = useGetContactDetailQuery({});
    const email = useMemo(() => {
      if (contactDetail?.data) {
        return contactDetail?.data.email;
      }
    }, [contactDetail.data]);
    const {openChat} = useWebchat();
    const {userContext} = useConsumerUser();

    const handleOpenChat = () => {
      pageClickEvent({page: Pages.PAYMENT_FAILED_DIALOG, cta: "got_it"});
      if (email) {
        openChat({
          data: {
            email,
            name: userContext?.user_name,
            query: "Hi! I'm having trouble processing a payment. Can you assist me, please?",
          },
        });
      }
    };

    useEffect(() => {
      pageViewEvent({page: Pages.PAYMENT_FAILED_DIALOG});
    }, []);

    let errorReasonText = InputUtils.prettierSnakeCaseSentence(error);
    let errorExplanationText = getExplanationText(error);
    if (errorReason && errorExplanation && !ERRORS_WITH_CUSTOM_HANDLING.includes(error)) {
      errorReasonText = errorReason;
      errorExplanationText = errorExplanation;
    }

    return (
      <PaymentFailedDialogContent
        error={error}
        errorReason={errorReason}
        errorReasonText={errorReasonText}
        errorExplanationText={errorExplanationText}
        errorOrigin={errorOrigin}
        errorCode={errorCode}
        secondaryButtonText={"Chat with us"}
        onClickSecondary={handleOpenChat}
      />
    );
  }
);

export default PaymentFailedDialog;
